export enum MacOSPlatforms {
  MACINTOSH = 'Macintosh',
  MACINTEL = 'MacIntel',
  MACPPC = 'MacPPC',
  MAC68K = 'Mac68K',
  MACOS = 'macOS',
}

export enum WindowsPlatforms {
  WIN32 = 'Win32',
  WIN64 = 'Win64',
  WINDOWS = 'Windows',
  WINCE = 'WinCE',
}

export enum iOSPlatforms {
  IPHONE = 'iPhone',
  IPAD = 'iPad',
  IPOD = 'iPod',
}
